<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span>For Edie,</span></p>
<p class="ded1"><span>who’s always been there</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0005.vue?17cd6cef